const VmPermissions = {
  // VIEW
  VIEW_VM_TAB: 'vm_platform__view',
  VIEW_VM_DASHBOARD: 'vm_dashboard__view',
  VIEW_VM_MANAGEMENT: 'vm_management__view',
  VIEW_VM_CONFIG: 'vm_configuration__view',
  VIEW_VM_CONFIGURATION: 'vm_configuration__config_view',

  // WRITE
  CREATE_VM_LICENSE_PLATE: 'vm_lp__create',
  CREATE_VM_AUTHORIZATION: 'vm_authorisation__create',
  TRANSFER_RECORDS: 'alerts__transfer',

  // UPDATE
  UPDATE_VM_LICENSE_PLATE: 'vm_lp__update',
  UPDATE_VM_RECORD: 'vm_record__update',

  // DELETE
  DELETE_VM_LICENSE_PLATE: 'vm_lp__delete',
  DELETE_VM_RECORD: 'vm_record__delete',
};

export default VmPermissions;
